import React from 'react';
import './pageSection.scss';
import Button from '../button/Button';

interface IProps {
  title: string;
  content: string;
  action?: {
    title: string;
    onClick: () => void;
  };
}

export default function PageSection(props: IProps) {
  const { title, content, action } = props;
  return (
    <div className="page-section">
      <div className="ui-page">
        <div className="page-section-text-group">
          <div>
            <h1 className="page-section-header page-section-header-secondary">
              {title}
            </h1>
            <br />
            <p>{content}</p>
          </div>
          {action ? (
            <Button
              size="medium"
              type="primary"
              onClick={action.onClick}
              letterSpacing="2px"
            >
              {action.title}
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
